import { Board } from 'domain/recruiting/recruitingBoard/shared';
import EmployeeMultiSelectFilter from './filter/EmployeeMultiSelectFilter';
import CandidateMultiSelectFilter from './filter/CandidateMultiSelectFilter';
import VacancyGroupStatusFilter from './filter/VacancyGroupStatusFilter';
import VacancyGroupFilter from './filter/VacancyGroupFilter';
import { Box } from '@mui/material';
import GenerateLinkForSycomButton from 'domain/recruiting/newVacancy/shared/button/GenerateLinkForSycomButton';
import { Filters, FiltersLayout, ListPageLayout } from 'framework/list';

const filters = (
  <Filters>
    <FiltersLayout>
      <VacancyGroupFilter source="specification:vacancyGroupByAlias" label="Vacancy Group" />
      <VacancyGroupStatusFilter source="specification:vacancyGroupByStatus" label="Vacancy Group Status" />
      <EmployeeMultiSelectFilter source="specification:vacancyGroupByDRI" label="DRI" />
      <EmployeeMultiSelectFilter source="specification:vacancyGroupBySourcer" label="Sourcer" />
      <EmployeeMultiSelectFilter source="specification:vacancyGroupByRecruiter" label="Recruiter" />
      <CandidateMultiSelectFilter source="specification:applicationByCandidateId" label="Candidate" />
    </FiltersLayout>
  </Filters>
);

const RecruitingBoardContent = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        width: '100%',
        '@supports (width: -webkit-fill-available)': {
          width: '-webkit-fill-available',
        },
        '@supports (width: -moz-available)': {
          width: '-moz-available',
        },
        maxWidth: '1654px',
      }}
    >
      <ListPageLayout
        sxPaper={{
          backgroundColor: 'transparent',
          padding: '0 !important',
        }}
        filter={filters}
        actions={[<GenerateLinkForSycomButton isUsingFromVacancyPage={false} />]}
      >
        <Board
          sx={{
            height: '100%',
            '@supports (height: -webkit-fill-available)': {
              height: '-webkit-fill-available',
            },
            '@supports (height: -moz-available)': {
              height: '-moz-available',
            },
            position: 'fixed',
            width: '100%',
            '@supports (width: -webkit-fill-available)': {
              width: '-webkit-fill-available',
            },
            '@supports (width: -moz-available)': {
              width: '-moz-available',
            },
            marginRight: '10px',
            marginBottom: '55px',
          }}
        />
      </ListPageLayout>
    </Box>
  );
};

export default RecruitingBoardContent;
